import { supabase } from '@/integrations/supabase/client';
import { WeeklyWellnessAssessment, DailyMealData, WellnessAnalysis } from './types';

export const directWellnessService = {
  /**
   * Get the latest wellness assessment for a family directly from the database
   */
  async getLatestWellnessAssessment(familyId: string): Promise<WeeklyWellnessAssessment | null> {
    try {
      const { data, error } = await supabase
        .from('weekly_wellness_assessments')
        .select('*')
        .eq('family_id', familyId)
        .order('week_start_date', { ascending: false })
        .limit(1)
        .single();

      if (error) {
        if (error.code === 'PGRST116') {
          // No rows found
          return null;
        }
        throw error;
      }

      // Type cast the JSON fields to their proper types
      return {
        ...data,
        meal_data: data.meal_data as unknown as DailyMealData[],
        wellness_analysis: data.wellness_analysis as unknown as WellnessAnalysis,
        openai_response: data.openai_response as any
      };
    } catch (error) {
      console.error('Error fetching latest wellness assessment:', error);
      return null;
    }
  }
};